import { AxiosPromise } from 'axios';

import { GetVoicesParams, PaginatedResponse, Voices } from 'shared/api';
import { apiInstance } from 'shared/api/typicode/base';

const BASE_URL = '/voices';

/**
 * Получение списка авторов для админки: bio/specialty приходят массивами по языкам.
 * Мобильный GET /voices отдаёт другой формат и не принимает sortBy/countryCode/language.
 */
export const getVoices = async (params: GetVoicesParams): AxiosPromise<PaginatedResponse<Voices>> =>
  apiInstance.get(`${BASE_URL}/all`, {
    params,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });

/**
 * Получение автора по идентификатору
 * @param id - Уникальный идентификатор автора
 * @returns Promise с данными автора
 */
export const getVoicesById = async (id: string): AxiosPromise<Voices> =>
  apiInstance.get(`${BASE_URL}/${id}`, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });

/**
 * Добавление нового автора
 * @param data - Данные нового автора (без поля _id)
 * @returns Promise с данными созданного автора
 */
export const postVoices = async (data: Omit<Voices, '_id'>): AxiosPromise<Voices> =>
  apiInstance.post(`${BASE_URL}`, data, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });

/**
 * Обновление существующего автора
 * @param id - Уникальный идентификатор автора для обновления
 * @param data - Обновлённые данные автора
 * @returns Promise с данными обновлённого автора
 */
export const patchVoices = async (id: string, data: Partial<Voices>): AxiosPromise<Voices> => {
  return apiInstance.patch(`${BASE_URL}/${id}`, data, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });
};

/**
 * Удаление автора по идентификатору
 * @param id - Уникальный идентификатор автора для удаления
 * @returns Promise с булевым значением, указывающим на успешность удаления
 */
export const deleteVoicesById = async (id: string): AxiosPromise<boolean> =>
  apiInstance.delete(`${BASE_URL}/${id}`, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });
